export const CONTRACT_TERMS_TEXT = `제1조 (목적)
본 계약은 예플랫(이하 "갑")과 계약 당사자(이하 "을") 간의 디지털 프로덕트 기획·디자인·개발 및 관련 서비스 제공에 관한 권리와 의무를 정함을 목적으로 합니다.

제2조 (계약의 범위)
갑은 을이 요청한 프로젝트의 범위, 일정, 산출물에 대해 상호 합의한 범위 내에서 서비스를 제공합니다. 범위 외 추가 요청은 별도 협의 후 진행됩니다.

제3조 (대금 및 지급)
계약 대금, 지급 일정, 선금/중도금/잔금 비율은 견적서 및 계약서에 명시된 내용을 따릅니다. 지급이 지연될 경우 일정 조정이 발생할 수 있습니다.

제4조 (지적재산권)
프로젝트 산출물의 지적재산권은 대금이 전액 지급된 후 을에게 귀속됩니다. 단, 갑이 보유한 공통 프레임워크, 라이브러리, 디자인 시스템 등은 갑의 자산으로 유지됩니다.

제5조 (비밀유지)
양 당사자는 계약 이행 과정에서 알게 된 상대방의 영업비밀 및 개인정보를 제3자에게 누설하지 않으며, 계약 종료 후에도 이를 준수합니다.

제6조 (해지)
일방 당사자가 계약을 위반하고 상당한 기간 내 시정하지 않을 경우, 상대방은 서면 통지로 계약을 해지할 수 있습니다.`;
